import $ from 'jquery';
import SidebarParamClinique from './sidebar-param-clinique'
import SidebarClinique from './sidebar-clinique'
import SidebarMDT from './sidebar-mdt'

export default {
    name: 'sidebar',
    components: {
        SidebarParamClinique, SidebarClinique,
        SidebarMDT
    },
    props: [],
    data() {
        return {
            user_role: '',           //  Role d'un utilisateur
            is_param: false
        }
    },
    computed: {
        /**
         * Get User info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },
    mounted() {
        if (this.userCredentials.roles.length > 0) {
            this.user_role = this.userCredentials.roles[0].nom;
        }

        this.getCurrentPath()
    },

    methods: {
        toggleClassChevron: function (htmlclass) {
            let className = $('.' + htmlclass + " .chevron i").attr('class')

            if (className === "fa fa-chevron-down ico-small") {
                $('.' + htmlclass + " .chevron i").removeClass('fa-chevron-down ico-small')
                $('.' + htmlclass + " .chevron i").addClass("fa-chevron-up ico-small")
            } else {
                $('.' + htmlclass + " .chevron i").removeClass('fa-chevron-up ico-small')
                $('.' + htmlclass + " .chevron i").addClass("fa-chevron-down ico-small")
            }
        },

        getCurrentPath() {
            let path = this.$route.path
            
            this.is_param = path.includes("parametres")
        }

    }
}


